module.exports={
	"Form": "LocationCreateManifest",
	"Descriptors": {
		"LocationDetails.Name": {
			"Name": "Name",
			"Hash": "CreateLocationName",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "LocationCreate",
				"Group": "LocationCreate"
			}
		},
		"LocationDetails.Description": {
			"Name": "Description",
			"Hash": "CreateLocationDescription",
			"DataType": "String",
			"PictForm": {
				"Row": "2",
				"InputType": "TextArea",
				"Section": "LocationCreate",
				"Group": "LocationCreate"
			}
		},
		"LocationDetails.QRCode": {
			"Name": "QR Code",
			"Hash": "CreateLocationQRCode",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "LocationCreate",
				"Group": "LocationCreate"
			}
		},
		"LocationDetails.ParentIDLocation": {
			"Name": "Linked To",
			"Hash": "CreateLocationParentIDLocation",
			"DataType": "String",
			"PictForm": {
				"Row": "2",
				"InputType": "Picker",
				"Section": "LocationCreate",
				"Group": "LocationCreate",
				"Entity": "Location"
			}
		}
	},
	"Sections": [
		{
			"Name": "Location Create",
			"Hash": "LocationCreate",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Location Create",
					"Hash": "LocationCreate",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
